import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    width: '100%',
    height: '100%',
    borderRadius: '16px',
    border: '1px solid var(--border)',
    backgroundColor: 'var(--card)',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  content: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  title: {
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '160%',
    letterSpacing: '0px',
    color: 'var(--foreground)',
  },
  description: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '143%',
    letterSpacing: '0.15px',
    color: 'var(--foreground)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '56px',
  },
  chip: {
    borderRadius: '999px',
    padding: '4px 8px',
    backgroundColor: 'pink',
  },
  chipContainer: {
    display: 'flex',
    gap: '8px',

    // '@media (max-width: 1660px)': {
    //   flexDirection: 'column',
    // },
    // '@media (max-width: 1535px)': {
    //   flexDirection: 'row',
    // },
    // '@media (max-width: 1320px)': {
    //   flexDirection: 'column',
    // },
    // '@media (max-width: 1095px)': {
    //   flexDirection: 'row',
    // },
    // '@media (max-width: 960px)': {
    //   flexDirection: 'column',
    // },
    // '@media (max-width: 950px)': {
    //   flexDirection: 'row',
    // },
    // '@media (max-width: 700px)': {
    //   flexDirection: 'column',
    // },
    // '@media (max-width: 375px)': {
    //   flexDirection: 'row',
    // },
  },
  chipText: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
  },
}));

export { useStyles };
